import { render, staticRenderFns } from "./home1.vue?vue&type=template&id=4518c0ac&"
import script from "./home1.vue?vue&type=script&lang=ts&"
export * from "./home1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports